import { useQuery } from "@tanstack/react-query";
import { type DatosFabricando } from "../../../../ts/api/API";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { Constantes } from "../../../../ts/constantes";
import { type BaseModalProps, BaseModal, ModalCloseCross } from "../../../../components/modals/BaseModal";
import { Loading } from "../../../../components/Loading/Loading";
import { FormImputar } from "./components/FormInputar";

interface ModalImputarFaseProps extends BaseModalProps {
	readonly idOF: number;
	readonly idFase: number;
}
export function ModalImputarFase(props: ModalImputarFaseProps) {
	const { data, isPending, error } = UseInfoFabricando({ idOF: props.idOF, idFase: props.idFase });

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h2 className="modal-title">
					<span>Imputar Fase:</span>
					<span>OF #{props.idOF}</span>
					{Constantes.existenFases ? (
						<span>- Fase {props.idFase}</span>
					) : null}
				</h2>
				<ModalCloseCross onClick={props.close} />
			</div>

			{data ? (
				<FormImputar
					datos={data}
					close={props.close}
				/>
			) : null}
			{isPending ? <Loading /> : null}
			{error ? <div>Error al cargar los datos</div> : null}

		</BaseModal>
	);
}






function UseInfoFabricando(params: { idOF: number, idFase: number; }) {
	return useQuery<DatosFabricando>({
		queryKey: ["getInfoFabricando", params],
		queryFn: () => ComunicacionAjax.sendAjaxRequest<DatosFabricando>("GET", "/api/v1/getInfoFabricando", params),
	});
}
